var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-end"},[_c('v-btn',{staticClass:"pa-2",attrs:{"icon":"","aria-label":"Close popup window"},on:{"click":_vm.onClicked}},[_c('v-icon',{staticClass:"icon-anim"},[_vm._v("\n      mdi-close\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }